import { PERMISSIONS_LIST } from '@/security/permissionsMapping';
class Permissions {
    static get values() {
        return PERMISSIONS_LIST;
    }
}

export default Permissions;
